<template>
  <div>
    <b-container class="py-3">
      <b-row>
        <b-col>
          <page-title title="Log Out" />
          <hr />
          <p>You have been logged out.</p>
          <b-link to="/">Continue</b-link>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import axios from "axios";
import AuthMixin from '../Mixins/AuthMixin.vue';

export default {
  name: "Logout",
  mixins: [AuthMixin],
  props: {},
  data() {
    return {
    }
  },
  methods: {
  },
  mounted () {
    this.logOut();
  }
};
</script>